import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { Subject } from 'rxjs';
import { AppInformationService, AuthService } from '../../core/core.module';
import { SharedModule } from '../shared.module';

@Component({
    selector: 'app-audit-dialog',
    templateUrl: './audit-dialog.component.html',
    styleUrls: ['./audit-dialog.component.scss'],
    standalone: false
})
export class AuditDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    title = 'Audit Log';
    auditLogs: any;
    auditLog: any[];

    @ViewChild('auditLogsMasterGrid') auditLogsMasterGrid: DxDataGridComponent;

    constructor(private appInfo: AppInformationService, public auth: AuthService) {}

    async ngOnInit() {
        this.auditLogs.forEach((auditLog) => {
            this.setChangesHTML(auditLog);
        });
    }

    setChangesHTML(auditLog: any) {
        let changesHTML = '<table class="audit-changes-table"><thead><tr><th>Field</th><th>Old Value</th><th>New Value</th></tr></thead><tbody>';
        auditLog.changes.forEach((change) => {
            changesHTML = `${changesHTML}<tr>`;
            changesHTML = `${changesHTML}<td>${change.columnName}</td>`;
            changesHTML = `${changesHTML}<td>${change.originalValue}</td>`;
            changesHTML = `${changesHTML}<td>${change.newValue}</td>`;
            changesHTML = `${changesHTML}</tr>`;
        });
        changesHTML = `${changesHTML}</tbody></table>`;
        auditLog.changesHTML = changesHTML;
    }

    selectionChange(e) {
        const selectedRowData = this.auditLogsMasterGrid.instance.getSelectedRowsData();
        if (selectedRowData.length > 0) {
            // this.auditLog = JSON.parse(e.selectedRowsData[0].data);
            this.auditLog = e.selectedRowsData[0].changes;
        } else {
            this.auditLog = null;
        }
    }

    close(): void {
        this.result.next({ result: false });
    }

    export() {
        SharedModule.onExportingGrid(this.auditLogsMasterGrid.instance, function (options) {
            options.excelCell.font = { name: 'Calibri', size: 10 };
            options.excelCell.alignment = { horizontal: 'left' };

            if (options.gridCell.rowType !== 'data' || !options.gridCell.column) return;

            if (options.gridCell.column.dataField === 'changesHTML') {
                let changes = 'Field --- Old Value --- New Value';
                options.gridCell.data.changes.forEach((change) => (changes = `${changes}\n${change.columnName} --- ${change.originalValue} --- ${change.newValue}`));
                options.excelCell.value = changes;
            }
        });
    }
}
